export default __webpack_public_path__ + "static/media/hexagon-inner-8.ed1816e6.svg";